import { newrelic } from "@jti/fe-clients";
import { getConfig } from "@jti/fe-common";
import type { OlaApiContract } from "@jti/rest-api-types";

import { createLegacyApiWarningAttributes, getIsEvo, getUser } from "../../utils";

import { OlaApiEvo } from "./OlaApiEvo";
import { OlaApiLegacy } from "./OlaApiLegacy";

/**
 * OLA - Offline Leads Actions
 */
export class OlaApi {
  static init(): OlaApiContract {
    const config = getConfig();
    const { ciam_token, uuid = "" } = getUser();

    if (config.USE_EVO_ONLY) {
      return new OlaApiEvo(config.EVO_DOMAIN, config.EVO_TENANT, ciam_token, uuid, config["X-RECAPTCHA-ID"]);
    }

    if (getIsEvo(config.OLA_URL)) {
      return new OlaApiEvo(
        config.OLA_URL,
        config.OLA_X_DES_AK_TENANT_TOKEN,
        ciam_token,
        uuid,
        config["X-RECAPTCHA-ID"]
      );
    }

    newrelic.sendWarning(
      "OlaApiLegacy initialized - legacy API client in use",
      createLegacyApiWarningAttributes(config, config.OLA_URL)
    );

    return new OlaApiLegacy(config.OLA_URL, config.OLA_X_DES_AK_TENANT_TOKEN, ciam_token, uuid);
  }
}
